export default __webpack_public_path__ + "static/mightyc-teaser2-tablet-03c6be28a135aac6a984972b6ff55767.png";